export default __webpack_public_path__ + "static/media/whiteCross.3c1aa49b.svg";